import React from 'react';
import { ReportNav } from '../ReportNav';
import { useReportNavigation } from '../hooks/useReportNavigation';

interface ReportLayoutProps {
  title: string;
  subtitle: string;
  meta?: string;
  children: React.ReactNode;
}

export const ReportLayout: React.FC<ReportLayoutProps> = ({
  title,
  subtitle,
  meta,
  children,
}) => {
  const { activeSection, navigateTo } = useReportNavigation();

  return (
    <div className="min-h-screen bg-white">
      <ReportNav activeSection={activeSection} onNavigate={navigateTo} />

      <div className="max-w-4xl mx-auto px-4 py-8 lg:pl-48">
        {/* Header */}
        <header className="text-center mb-16 pt-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {title}
          </h1>
          <p className="text-xl text-gray-600 mb-2">
            {subtitle}
          </p>
          {meta && (
            <p className="text-sm text-gray-500">
              {meta}
            </p>
          )}
        </header>

        {children}
      </div>
    </div>
  );
};

// Section divider for between sections
export const SectionDivider: React.FC = () => (
  <hr className="my-12 border-gray-200" />
);
